/* Dashboard Builder — named-board (preset) load/save hooks. */
import { useCallback, useEffect, useState } from 'react';
import { api } from '@/lib/api';
import {
  DashPage, LayoutScope, TileInstance, BandColors, Preset, PresetsResponse,
} from './types';

export function usePresets(page: DashPage) {
  const [resp, setResp] = useState<PresetsResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get<PresetsResponse>(`/dashboards/presets?page=${page}`);
      setResp(r.data);
    } catch {
      setResp(null);
    } finally {
      setLoading(false);
    }
  }, [page]);
  useEffect(() => { void reload(); }, [reload]);
  return { resp, loading, reload };
}

export async function createPreset(
  page: DashPage, scope: LayoutScope, name: string, tiles: TileInstance[], colors: Partial<BandColors>,
): Promise<Preset> {
  const r = await api.post<Preset>('/dashboards/presets', { page, scope, name, tiles, colors });
  return r.data;
}

export async function updatePreset(
  id: string, name: string, tiles: TileInstance[], colors: Partial<BandColors>,
): Promise<Preset> {
  const r = await api.put<Preset>(`/dashboards/presets/${id}`, { name, tiles, colors });
  return r.data;
}

export async function deletePreset(id: string): Promise<void> {
  await api.delete(`/dashboards/presets/${id}`);
}

export async function setDefaultPreset(
  page: DashPage, presetId: string | null, tenant = false,
): Promise<void> {
  await api.put('/dashboards/default', { page, preset_id: presetId, tenant });
}
